export default "__VITE_ASSET__FQhVYurN__"